import { render, staticRenderFns } from "./promptPage.vue?vue&type=template&id=9e154e68&scoped=true"
import script from "./promptPage.vue?vue&type=script&lang=js"
export * from "./promptPage.vue?vue&type=script&lang=js"
import style0 from "./promptPage.vue?vue&type=style&index=0&id=9e154e68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e154e68",
  null
  
)

export default component.exports